import { setLocalStorage } from "../utils/localStorageUtils";
import Http from "./http";

const SigninGetAll = async (data:any) =>  {

    const response = await Http.post('/users/login',  data).then(
      response =>{
        if(response.status === 200){
          setLocalStorage('client_id', response.data.UserData[0]._id  );       
          setLocalStorage("AccessToken",response.data.Token);
          setLocalStorage("AuthData",  response.data);
          window.dispatchEvent(new Event('triggeruserArea'));
          
        }
        return response;
      }
    ).catch(error=>{
      return error;
    });  
   return response;
  
  }

  export const signinservices = {
    SigninGetAll
  }